import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'sev2',
});

export const feedbackRouteRef = createRouteRef({
  id: 'sev2-feedback',
});

export const athSeRouteRef = createRouteRef({
  id: 'sev2-ath-se',
});

export const engineerPerformanceRouteRef = createRouteRef({
  id: 'sev2-engineer-performance',
});
